import React from 'react';
import { motion } from 'framer-motion';

export default function AboutHeroSection() {
  const img = `${process.env.PUBLIC_URL}/aboutus.jpg`;
  const fallback = `${process.env.PUBLIC_URL}/images/aboutus.png`;

  return (
    <section className="w-full bg-white min-h-[100svh] flex items-center">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 items-center">
        {/* Left: copy */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-neutral-900">About Us</h1>

          <div className="mt-8 space-y-6">
            <p className="text-xl md:text-2xl font-semibold text-neutral-900 leading-snug">
              At Lincoln AIM, we believe in building a collaborative environment where motivated
              individuals can grow and succeed.
            </p>

            <p className="text-base md:text-lg leading-relaxed text-neutral-700">
              We foster a meritocracy where your contributions truly matter, and we provide training
              and support to help you reach your full potential.
            </p>

            <div className="pt-2">
              <p className="text-xl md:text-2xl font-semibold text-neutral-900">
                We’re currently <span className="text-amber-700">hiring!</span>
              </p>
              <p className="text-sm md:text-base text-neutral-700 mt-2">
                If you’re interested in joining a dynamic and supportive team, please apply by emailing us at:
              </p>
            </div>

            <div className="pt-2">
              <a
                href="mailto:ops@lincolnaim.com"
                className="inline-flex items-center gap-3 rounded-full
                           bg-gradient-to-r from-stone-200 to-stone-300
                           px-6 py-3 text-base md:text-lg font-medium text-neutral-800
                           shadow-md shadow-neutral-300/40 hover:from-stone-300 hover:to-stone-200
                           hover:shadow-lg transition duration-300 ease-out"
              >
                <span className="text-xl text-neutral-600">📧</span>
                ops@lincolnaim.com
              </a>
            </div>
          </div>
        </motion.div>

        {/* Right: smaller image */}
        <motion.div
          className="
    relative w-full
    h-[300px] sm:h-[340px] md:h-[380px] lg:h-[400px]
    max-w-[520px] md:max-w-[560px] lg:max-w-[600px]
    justify-self-end rounded-2xl overflow-hidden shadow-xl
  "
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.15 }}
        >
          <img
            src={img}
            alt="Office overlooking city skyline"
            className="absolute inset-0 w-full h-full object-cover object-[50%_45%]"
            loading="eager"
            decoding="async"
            onError={(e) => {
              if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
            }}
          />
        </motion.div>

      </div>
    </section>
  );
}
